export default "__VITE_ASSET__CHe6uQjE__"